export const capitalizeString = (str: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

export function capitalizeArrayOfString(array: string[]) {
  if (Array.isArray(array)) return array.map(capitalizeString);

  return array;
}
